<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './leaseContractPage';

  export default {
    name: 'auditLeaseContract',
    components: {
      baseEdit,
    },
  };
</script>
